import Pwa from "./Pwa.js";
import Cookie from "js-cookie";

export default {
  getCookie() {
    let token = Cookie.get("XSRF-TOKEN");

    if (token) {
      return new Promise((resolve) => {
        resolve(token);
      });
    }

    return Pwa.get("/sanctum/csrf-cookie");
  },
};
